// Brand tokens for the pass landing page — mirrors the home page
// (LandingPage.tsx) Mobile.Digital palette so the two stay consistent.
export const BRAND = {
  ink: '#06251B',
  forest: '#0A3B2C',
  forest2: '#0E4A38',
  lime: '#AEDD1F',
  limeDark: '#8FB918', // wordmark suffix shade used by the home page nav
  cream: '#F5F8F1',
  muted: '#56675E',
  line: '#E4EAE2',
};
